var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogLayout',{staticClass:"sms-biz-message-logger",attrs:{"title":"消息发送日志"}},[(_vm.rowData.sendNote)?[_c('AppScrollbar',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"logger-main"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.rowData.sendNote))])])])]:[_c('Hint',[_c('div',[_vm._v("日志内容为空")])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }